var map = {
	"./DreamerScholarship.jpg": 109,
	"./gallery-0.jpg": 724,
	"./gallery-1.jpg": 769,
	"./gallery-10.jpg": 589,
	"./gallery-11.jpg": 272,
	"./gallery-12.jpg": 255,
	"./gallery-13.jpg": 866,
	"./gallery-14.jpg": 233,
	"./gallery-15.jpg": 708,
	"./gallery-16.jpg": 363,
	"./gallery-17.jpg": 318,
	"./gallery-18.jpg": 973,
	"./gallery-19.jpg": 80,
	"./gallery-2.jpg": 686,
	"./gallery-3.jpg": 523,
	"./gallery-4.jpg": 520,
	"./gallery-5.jpg": 685,
	"./gallery-6.jpg": 82,
	"./gallery-7.jpg": 919,
	"./gallery-8.jpg": 500,
	"./gallery-9.jpg": 545
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 291;